import React, {
  useState,
  useEffect,
}                           from 'react';
import { historyPropType }  from '~/config/routerPropTypes';
import { showPartner }      from '~/config/routes';
import Request              from '~/providers/Request';
import PartnerRecord        from '~/records/PartnerRecord';
import Form                 from './Form';

function EditRecord({history}){
  const [ record, setRecord] = useState(new PartnerRecord());
  const [ loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      setLoading(true);
      Request.get(`/admin/partner/${id}`, {})
        .then( response => {
          setLoading(false);
          // addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  async function onSubmit (){
    const data = record.toParams({doctor: true});

    Request.put(`/admin/partner/${id}`, data, {}, { controller: 'partner' })
      .then((resp) => {
        setLoading(false);
        history.push(showPartner.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
